import React from "react"; 
import Dashboard from "../Pages/Main/Dashboard"; 
import Employees from "../Pages/Main/Employee/Employees"; 
import EmployeeForm from "../Pages/Main/Employee/EmployeeForm"; 
import Agents from "../Pages/Main/Agent/Agents"; 
import AddAgentForm from "../Pages/Main/Agent/AddAgentForm"; 
import AgentDashboard from "../Pages/Main/Agent/AgentDashboard"; 
import RetailersView from "../Pages/Main/Agent/Retailer/RetailersView"; 
import Retailers from "../Pages/Main/Agent/Retailer/Retailers"; 
import EmployeeDashboard from "../Pages/Employee/Dashboard"; 
import AddRetailerForm from "../Pages/Main/Agent/Retailer/UpdateRetailerForm"; 
import LeadsViewPage from "../Pages/Employee/LeadsViewPage"; 
import OperationDashboard from "../Pages/Main/Operation/Dashboard"; 
import OprRetailersView from "../Pages/Main/Operation/RetailersView"; 
import RetailersPage from "../Pages/Main/Operation/RetailersPage"; 
import TasksView from "../Pages/Main/Operation/TasksView"; 
import ReportsView from "../Pages/Main/Operation/ReportsView"; 
import CommissionView from "../Pages/Main/Agent/CommissionView"; 
import RetailerDashboard from "../Pages/Main/Retailer/RetailerDashboard"; 
import WarrantyView from "../Pages/Main/Retailer/WarrantyView"; 
import InvoicesView from "../Pages/Main/Retailer/InvoicesView"; 
import LedgerView from "../Pages/Main/Retailer/LedgerView"; 
import UsersView from "../Pages/Main/Retailer/UsersView"; 
import DocumentsView from "../Pages/Main/Retailer/DocumentsView"; 
import RetailerUserDashboard from "../Pages/Main/RetailerUser/RetailerUserDashboard"; 
import UsrWarrantyView from "../Pages/Main/RetailerUser/WarrantyView"; 
import LegalView from "../Pages/Main/RetailerUser/LegalView"; 
import ProfileView from "../Pages/Main/RetailerUser/ProfileView"; 
import CustomerWarrantyPortal from "../Pages/Main/Customer/CustDashboard"; 
import WarrantiesView from "../Pages/Main/Customer/WarrantiesView"; 
import ClaimsView from "../Pages/Main/Customer/ClaimsView"; 
import CustLegalView from "../Pages/Main/Customer/LegalView"; 
import SupportView from "../Pages/Main/Customer/SupportView"; 
import AdminSuperPortal from "../Pages/Main/Admin/AdminSuperPortal"; 
import OverviewView from "../Pages/Main/Admin/OverviewView"; 
import OperationsView from "../Pages/Main/Admin/OperationsView"; 
import RetailerUsersView from "../Pages/Main/Admin/RetailerUsersView"; 
import AgentsView from "../Pages/Main/Admin/AgentsView"; 
import WarrantiesClaimsView from "../Pages/Main/Admin/WarrantiesClaimsView/WarrantiesClaimsView"; 
import CommissionsView from "../Pages/Main/Admin/CommissionsView"; 
import AdTasksView from "../Pages/Main/Admin/TasksView"; 
import LegalComplianceView from "../Pages/Main/Admin/LegalComplianceView"; 
import AnalyticsView from "../Pages/Main/Admin/Analytics/AnalyticsView"; 
import RetailerDetailsPage from "../Pages/Main/Operation/RetailerDetailsPage"; 
import SuperAdminPortal from "../Pages/Main/SuperAdmin/SuperAdminPortal"; 
import CategoriesView from "../Pages/Main/SuperAdmin/CategoriesView"; 
import BrandView from "../Pages/Main/SuperAdmin/BrandView"; 
import ProductView from "../Pages/Main/SuperAdmin/ProductView"; 
import Account from "../Pages/Profile/Account"; 
import AddEntityForm from "../Pages/Main/Admin/AddEntityForm"; 
import CompanyView from "../Pages/Main/Admin/CompanyView"; 

import BadgePackageDashboard from "../Pages/Badge&Package/BadgePackageDashboard"; 
// import AssignCompanyProducts from "../Pages/Main/Admin/AssignCompanyProducts"; 
import Keys from "../Pages/Main/SuperAdmin/Keys/Keys";
import PriceTemplate from "../Pages/Main/SuperAdmin/PriceTemplate";
import WarrantyDetails from "../Pages/Main/Admin/WarrantyDetails";
import UserDetails from "../Pages/ViewDetail/UserDetails";
import CreateCustomer from "../Pages/Main/Retailer/CreateCustomer/CreateCustomer";
import DeviceModelsPage from "../Pages/Main/Admin/DeviceModelsPage";
import OpsAllocationDistrictMap from "../Pages/Main/Admin/Assign Map/OpsAllocationDistrictMap";
import OverView from "../Pages/Main/Admin/OverView";
import QuestionnaireBuilder from "../Pages/Main/Admin/QuestionnaireBuilder";
import RetailerOnboarding from "../Pages/Main/Agent/Retailer/RetailerOnboarding";
import CustomerList from "../Pages/Main/Retailer/CustomerList";
import CustomerDetails from "../Pages/Main/Customer/CustomerDetails";
import CompanyPaymentsList from "../Pages/Main/Admin/CompanyPaymentsList";
import PaymentDetails from "../Pages/Main/Admin/PaymentDetails";
import TeamMember from "../Pages/Employee/TeamMember";
import RetailerWarrantyEarningsDashboard from "../Pages/Main/Earning/RetailerWarrantyEarningsDashboard";
import ResetPassword from "../Pages/Login/ResetPassword";
import InvoiceDetailsUI from "../Pages/Main/Retailer/Invoice/InvoiceDetailsUI";
import InvoicePage from "../Pages/Main/Retailer/Invoice/InvoicePage";
import InvoiceDetails from "../Pages/Main/Retailer/Invoice/InvoiceDetails";
import InvoiceDetailsPage from "../Pages/Main/Retailer/Invoice/InvoiceDetailsPage";
import RetailerProductView from "../Pages/Main/Retailer/Products/RetailerProductView";
import EmployeeDetails from "../Pages/Main/Employee/EmployeeDetails";
import BrandModelPage from "../Pages/Main/SuperAdmin/BrandModelsPage";
import ModelPriceList from "../Pages/Main/Retailer/ModelPriceList";
import RetailerTransactions from "../Pages/Main/Retailer/RetailerTransactions";
import Whatsappmessage from "../Pages/Main/SuperAdmin/ReportPanel/Whatsappmessage";
import WhatsappPanel from "../Pages/Main/SuperAdmin/ReportPanel/WhatsappPanel";
import ActivationReport from "../Pages/Main/Admin/ActivationReport";
import OrderCheckoutPage from "../Pages/Main/Retailer/Products/Ordercheckoutpage";
import CommissionDetailView from "../Pages/Main/Admin/Commissiondetailview";


const allRoutes = [ 
    
    // super admin 
    { id: "superdashboard", path: "/superdashboard", component: <SuperAdminPortal />, roles: ["admin"],}, 
    // { id: "overview", path: "/overview", component: <QuestionnaireBuilder />, roles: ["admin"],}, 
    { id: "categories", path: "/categories", component: <CategoriesView />, roles: ["admin"],}, 
    { id: "brands", path: "/brands", component: <BrandView />, roles: ["admin"], }, 
    { id: "brands", path: "/admin/brand/:id/models", component: <BrandModelPage />, roles: ["admin"], }, 
    { id: "products", path: "/products", component: <ProductView />, roles: ["admin","company"], }, 
    { id: "dashboard", path: "/dashboard", component: <AdminSuperPortal />, roles: ["company"], }, 
    { id: "amdcomp", path: "/amdcomp", component: <CompanyView />, roles: ["admin"], }, 
    // { id: "allemployees", path: "/allemployees", component: <Employees />, roles: [ "company"], }, 
    // { id: "empdetails", path: "/employees/:id", component: <EmployeeDetails />, roles: [ "company"], }, 
    { id: "add-employee", path: "/add-employee", component: <EmployeeForm />, roles: ["admin","company"], }, 
    { id: "allagents", path: "/allagents", component: <Agents />, }, 
    { id: "add-agent", path: "/add-agent", component: <AddAgentForm /> }, 
    { id: "allretailers", path: "/allretailers", component: <Retailers /> }, 
    { id: "add-retailer", path: "/add-retailer", component: <AddRetailerForm /> }, 
    { id: "add-entity", path: "/add-entity", component: <AddEntityForm />, roles: ["admin","company","employee", "agent","retailer"], },
    { id: "keys", path:"/keys", component: <Keys />,roles: ["admin"], },
    { id: "pricetemplate", path:"/pricetemplate", component: <PriceTemplate />,roles: ["admin", "company"], },
    { id: "companydetails", path:"/user/:id", component: <UserDetails />,roles: ["admin","company", "agent","employee","retailer"], },
    { id: "devicemodal", path:"/devicemodal", component: <DeviceModelsPage />,roles: ["admin"], },
    { id: "assignmap", path:"/assignmap", component: <OpsAllocationDistrictMap />,roles: ["admin"], },
    
    // Admin Dashboard 
    { id: "admindashboard", path: "/admindashboard", component: <AdminSuperPortal />,roles: ["company"], }, 
    { id: "paymentlist", path: "/paymentlist", component: <CompanyPaymentsList />,roles: ["admin"], }, 
    { id: "payment-details", path: "/company/payment-details/:paymentId", component: <PaymentDetails />,roles: ["admin","company"], }, 
    { id: "admretailers", path: "/admretailers", component: <OperationsView />, roles: ["admin", "agent"], }, 
    { id: "admagents", path: "/admagents", component: <AgentsView />,roles: ["admin","company"], }, 
    { id: "admwrnty", path: "/admwrnty", component: <WarrantiesClaimsView />, roles: ["admin","agent","retailer"],}, 
    { id: "admcomsn", path: "/admcomsn", component: <CommissionsView />,roles: ["admin"], }, 
    { id: "comdetail", path: "/commission-details", component: <CommissionDetailView />,roles: ["admin"], }, 
    // { id: "admtask", path: "/admtask", component: <AdTasksView />, roles: ["admin","company"], }, 
    { id: "admlegal", path: "/admlegal", component: <LegalComplianceView />, roles: ["admin","company", "agent"], }, 
    { id: "admretuser", path: "/admretuser", component: <RetailerUsersView />, roles: ["admin", "agent"], }, 
    // { id: "admanltc", path: "/admanltc", component: <AnalyticsView />, roles: ["admin","company", "agent"], }, 
    // { id: "assignproduct", path:"/assign-products/:companyId", component: <AssignCompanyProducts />, roles: ["admin"] },
    { id: "warrantydetail", path:"/warranty-details/:id", component: <WarrantyDetails />, roles: ["admin","company", "retailer", "retailer_user" ] },
    { id: "employeeadd", path:"/employees/add", component: <EmployeeForm />, roles: ["company"] },
    { id: "employeeadd", path:"/employees/edit/:id", component: <EmployeeForm />, roles: ["company"] },
    { id: "report-logs", path:"/report-logs", component: <WhatsappPanel />,roles: ["admin"], },
    { id: "activation-report", path:"/activation-report", component: <ActivationReport />,roles: ["admin","company","retailer"], },

    // employee dashboard 
    { id: "empdash", path: "/empdashboard", component: <EmployeeDashboard />, roles: ["admin","company", "agent", "employee"], }, 
    { id: "leadview", path:"/leads-view", component: <LeadsViewPage />,roles: ["admin","company", "agent","employee"], }, 
    { id: "badgepackage", path:"/badgepackage", component: <BadgePackageDashboard />,roles: ["admin","company", "agent","employee"], },
    { id: "Team Members", path:"/teammember", component: <TeamMember />,roles: ["admin","employee"], },

    // Operation Dashboard 
    { id: "oprdash", path:"/oprdashboard", component: <OperationDashboard />, roles: ["admin","company", "agent","employee"],}, 
    { id: "oprret", path:"/oprretail", component: <OprRetailersView />,roles: ["admin","company", "agent","employee"],}, 
    { id: "cardret", path:"/retailers", component: <RetailersPage />,roles: ["admin","company", "agent","employee"],}, 
    // { id: "", path:"/oprtasks", component: <TasksView />, roles: ["admin","company", "agent","employee"],}, 
    { id: "oprreports", path:"/oprreports", component: <ReportsView />, roles: ["admin","company", "agent","employee"],}, 
    { id: "retailerview", path:"/retailer/:id", component: <RetailerDetailsPage />,roles: ["admin","company", "agent","employee"],}, 

    // Agent Dashboard 
    { id: "agentdashboard", path: "/agentdashboard", component: <SuperAdminPortal />,roles: ["agent"], }, 
    { id: "agentretailers", path: "/agentretailers", component: <RetailersView />,roles: ["agent"], }, 
    { id: "agtcom", path: "/agtcom", component: <CommissionView />, roles: ["agent"], }, 

    // Retailer Dashboard 
    { id: "retaileronboard", path: "/onboard", component: <RetailerOnboarding />, roles: ["company","agent","retailer","retailer_user"], }, 
    { id: "retailerdashboard", path: "/retailerdashboard", component: <RetailerDashboard />,roles: ["retailer"], }, 
    { id: "retwarnty", path: "/retwarnty", component: <WarrantyView />,roles: ["retailer", "retailer_user"], }, 
    // { id: "retinv", path: "/retinv", component: <InvoicesView />,roles: ["retailer"], },
    { id: "retinv", path: "/retinv", component: <InvoicesView />,roles: ["retailer", "admin", "retailer_user"], },
    { id: "retinv", path: "/invoices/:invoiceId", component: <InvoiceDetailsPage />,roles: ["retailer", "company"], },
    { id: "retproduct", path: "/retproduct", component: <RetailerProductView />,roles: ["retailer", ], },
    { id: "ordersummery", path: "/ordersummery", component: <OrderCheckoutPage />,roles: ["retailer", ], },
    // { id: "retledger", path: "/retledger", component: <LedgerView />, roles: ["retailer"], },
    { id: "retuser", path: "/retuser", component: <UsersView />, roles: ["retailer"], }, 
    { id: "retuserdoc", path: "/retuserdoc", component: <DocumentsView />, roles: ["retailer"], },
    { id: "customer-create", path: "/customer-create", component: <CreateCustomer />, roles: ["retailer", "retailer_user"], },
    { id: "customerlist", path: "/customerlist", component: <CustomerList />, roles: ["admin","retailer", "retailer_user"], },
    { id: "customer-details", path: "/customer-details/:id", component: <CustomerDetails />, roles: ["admin","company", "agent","retailer", "retailer_user"], },
    { id: "earnings", path: "/earnings", component: <RetailerWarrantyEarningsDashboard />, roles: ["admin","company", "agent","retailer", "retailer_user"], },
    { id: "modelpricelist", path: "/model-price-list", component: <ModelPriceList />, roles: ["admin","company","employee", "agent","retailer", "retailer_user"], },
    { id: "rettransac", path: "/retailer-transactions", component: <RetailerTransactions />, roles: ["retailer"], },

    // User Dashboard 
    { id: "userdashboard", path: "/userdashboard", component: <RetailerDashboard />,roles: ["retailer_user"], }, 
    // { id: "userwarnty", path: "/userwarnty", component: <UsrWarrantyView />,roles: ["retailer_user"], }, 
    // { id: "userdoc", path: "/userdoc", component: <LegalView />,roles: ["retailer_user"], }, 
    { id: "userprofile", path: "/userprofile", component: <ProfileView />, roles: ["retailer_user"], }, 

    // Customer Dashboard
    { id: "custdashboard", path: "/custdashboard", component: <CustomerWarrantyPortal />, roles: ["customer"] }, 
    { id: "custwarnty", path: "/custwarnty", component: <WarrantiesView />, roles: ["customer"] }, 
    { id: "custclaims", path: "/custclaims", component: <ClaimsView />, roles: ["customer"] }, 
    { id: "custwarnty", path: "/custwarnty", component: <WarrantiesView />, roles: ["customer"] }, 
    { id: "custdoc", path: "/custdoc", component: <CustLegalView />, roles: [ "customer"] },
    { id: "custspt", path: "/custspt", component: <SupportView />, roles: ["customer"] },

    // Profile 
    { id: "profile", path: "/profile", component: <ProfileView />, roles: ["admin","company","agent","employee","retailer", "customer"] }, 
    { id: "account", path: "/account", component: <Account />, roles: ["admin","company", "employee","agent","retailer", "customer"] },
    // { id: "reset-password", path: "/reset-password", component: <ResetPassword />, roles: ["admin","company", "employee","agent","retailer","retailer_user", "customer"] },
    // error page 
    
]; 

export default allRoutes;

//*********************************************original code**************************************************/

// import React from "react"; 
// import Dashboard from "../Pages/Main/Dashboard"; 
// import Employees from "../Pages/Main/Employee/Employees"; 
// import EmployeeForm from "../Pages/Main/Employee/EmployeeForm"; 
// import Agents from "../Pages/Main/Agent/Agents"; 
// import AddAgentForm from "../Pages/Main/Agent/AddAgentForm"; 
// import AgentDashboard from "../Pages/Main/Agent/AgentDashboard"; 
// import RetailersView from "../Pages/Main/Agent/Retailer/RetailersView"; 
// import Retailers from "../Pages/Main/Agent/Retailer/Retailers"; 
// import EmployeeDashboard from "../Pages/Employee/Dashboard"; 
// import AddRetailerForm from "../Pages/Main/Agent/Retailer/UpdateRetailerForm"; 
// import LeadsViewPage from "../Pages/Employee/LeadsViewPage"; 
// import OperationDashboard from "../Pages/Main/Operation/Dashboard"; 
// import OprRetailersView from "../Pages/Main/Operation/RetailersView"; 
// import RetailersPage from "../Pages/Main/Operation/RetailersPage"; 
// import TasksView from "../Pages/Main/Operation/TasksView"; 
// import ReportsView from "../Pages/Main/Operation/ReportsView"; 
// import CommissionView from "../Pages/Main/Agent/CommissionView"; 
// import RetailerDashboard from "../Pages/Main/Retailer/RetailerDashboard"; 
// import WarrantyView from "../Pages/Main/Retailer/WarrantyView"; 
// import InvoicesView from "../Pages/Main/Retailer/InvoicesView"; 
// import LedgerView from "../Pages/Main/Retailer/LedgerView"; 
// import UsersView from "../Pages/Main/Retailer/UsersView"; 
// import DocumentsView from "../Pages/Main/Retailer/DocumentsView"; 
// import RetailerUserDashboard from "../Pages/Main/RetailerUser/RetailerUserDashboard"; 
// import UsrWarrantyView from "../Pages/Main/RetailerUser/WarrantyView"; 
// import LegalView from "../Pages/Main/RetailerUser/LegalView"; 
// import ProfileView from "../Pages/Main/RetailerUser/ProfileView"; 
// import CustomerWarrantyPortal from "../Pages/Main/Customer/CustDashboard"; 
// import WarrantiesView from "../Pages/Main/Customer/WarrantiesView"; 
// import ClaimsView from "../Pages/Main/Customer/ClaimsView"; 
// import CustLegalView from "../Pages/Main/Customer/LegalView"; 
// import SupportView from "../Pages/Main/Customer/SupportView"; 
// import AdminSuperPortal from "../Pages/Main/Admin/AdminSuperPortal"; 
// import OverviewView from "../Pages/Main/Admin/OverviewView"; 
// import OperationsView from "../Pages/Main/Admin/OperationsView"; 
// import RetailerUsersView from "../Pages/Main/Admin/RetailerUsersView"; 
// import AgentsView from "../Pages/Main/Admin/AgentsView"; 
// import WarrantiesClaimsView from "../Pages/Main/Admin/WarrantiesClaimsView/WarrantiesClaimsView"; 
// import CommissionsView from "../Pages/Main/Admin/CommissionsView"; 
// import AdTasksView from "../Pages/Main/Admin/TasksView"; 
// import LegalComplianceView from "../Pages/Main/Admin/LegalComplianceView"; 
// import AnalyticsView from "../Pages/Main/Admin/Analytics/AnalyticsView"; 
// import RetailerDetailsPage from "../Pages/Main/Operation/RetailerDetailsPage"; 
// import SuperAdminPortal from "../Pages/Main/SuperAdmin/SuperAdminPortal"; 
// import CategoriesView from "../Pages/Main/SuperAdmin/CategoriesView"; 
// import BrandView from "../Pages/Main/SuperAdmin/BrandView"; 
// import ProductView from "../Pages/Main/SuperAdmin/ProductView"; 
// import Account from "../Pages/Profile/Account"; 
// import AddEntityForm from "../Pages/Main/Admin/AddEntityForm"; 
// import CompanyView from "../Pages/Main/Admin/CompanyView"; 

// import BadgePackageDashboard from "../Pages/Badge&Package/BadgePackageDashboard"; 
// // import AssignCompanyProducts from "../Pages/Main/Admin/AssignCompanyProducts"; 
// import Keys from "../Pages/Main/SuperAdmin/Keys/Keys";
// import PriceTemplate from "../Pages/Main/SuperAdmin/PriceTemplate";
// import WarrantyDetails from "../Pages/Main/Admin/WarrantyDetails";
// import UserDetails from "../Pages/ViewDetail/UserDetails";
// import CreateCustomer from "../Pages/Main/Retailer/CreateCustomer/CreateCustomer";
// import DeviceModelsPage from "../Pages/Main/Admin/DeviceModelsPage";
// import OpsAllocationDistrictMap from "../Pages/Main/Admin/Assign Map/OpsAllocationDistrictMap";
// import OverView from "../Pages/Main/Admin/OverView";
// import QuestionnaireBuilder from "../Pages/Main/Admin/QuestionnaireBuilder";
// import RetailerOnboarding from "../Pages/Main/Agent/Retailer/RetailerOnboarding";
// import CustomerList from "../Pages/Main/Retailer/CustomerList";
// import CustomerDetails from "../Pages/Main/Customer/CustomerDetails";
// import CompanyPaymentsList from "../Pages/Main/Admin/CompanyPaymentsList";
// import PaymentDetails from "../Pages/Main/Admin/PaymentDetails";
// import TeamMember from "../Pages/Employee/TeamMember";
// import RetailerWarrantyEarningsDashboard from "../Pages/Main/Earning/RetailerWarrantyEarningsDashboard";
// import ResetPassword from "../Pages/Login/ResetPassword";
// import InvoiceDetailsUI from "../Pages/Main/Retailer/Invoice/InvoiceDetailsUI";
// import InvoicePage from "../Pages/Main/Retailer/Invoice/InvoicePage";
// import InvoiceDetails from "../Pages/Main/Retailer/Invoice/InvoiceDetails";
// import InvoiceDetailsPage from "../Pages/Main/Retailer/Invoice/InvoiceDetailsPage";
// import RetailerProductView from "../Pages/Main/Retailer/Products/RetailerProductView";
// import EmployeeDetails from "../Pages/Main/Employee/EmployeeDetails";
// import BrandModelPage from "../Pages/Main/SuperAdmin/BrandModelsPage";
// import ModelPriceList from "../Pages/Main/Retailer/ModelPriceList";
// import RetailerTransactions from "../Pages/Main/Retailer/RetailerTransactions";
// import Whatsappmessage from "../Pages/Main/SuperAdmin/ReportPanel/Whatsappmessage";
// import WhatsappPanel from "../Pages/Main/SuperAdmin/ReportPanel/WhatsappPanel";
// import ActivationReport from "../Pages/Main/Admin/ActivationReport";
// import OrderCheckoutPage from "../Pages/Main/Retailer/Products/Ordercheckoutpage";


// const allRoutes = [ 
    
//     // super admin 
//     { id: "superdashboard", path: "/superdashboard", component: <SuperAdminPortal />, roles: ["admin"],}, 
//     // { id: "overview", path: "/overview", component: <QuestionnaireBuilder />, roles: ["admin"],}, 
//     { id: "categories", path: "/categories", component: <CategoriesView />, roles: ["admin"],}, 
//     { id: "brands", path: "/brands", component: <BrandView />, roles: ["admin"], }, 
//     { id: "brands", path: "/admin/brand/:id/models", component: <BrandModelPage />, roles: ["admin"], }, 
//     { id: "products", path: "/products", component: <ProductView />, roles: ["admin","company"], }, 
//     { id: "dashboard", path: "/dashboard", component: <AdminSuperPortal />, roles: ["company"], }, 
//     { id: "amdcomp", path: "/amdcomp", component: <CompanyView />, roles: ["admin"], }, 
//     // { id: "allemployees", path: "/allemployees", component: <Employees />, roles: [ "company"], }, 
//     // { id: "empdetails", path: "/employees/:id", component: <EmployeeDetails />, roles: [ "company"], }, 
//     { id: "add-employee", path: "/add-employee", component: <EmployeeForm />, roles: ["admin","company"], }, 
//     { id: "allagents", path: "/allagents", component: <Agents />, }, 
//     { id: "add-agent", path: "/add-agent", component: <AddAgentForm /> }, 
//     { id: "allretailers", path: "/allretailers", component: <Retailers /> }, 
//     { id: "add-retailer", path: "/add-retailer", component: <AddRetailerForm /> }, 
//     { id: "add-entity", path: "/add-entity", component: <AddEntityForm />, roles: ["admin","company","employee", "agent","retailer"], },
//     { id: "keys", path:"/keys", component: <Keys />,roles: ["admin"], },
//     { id: "pricetemplate", path:"/pricetemplate", component: <PriceTemplate />,roles: ["admin", "company"], },
//     { id: "companydetails", path:"/user/:id", component: <UserDetails />,roles: ["admin","company", "agent","employee","retailer"], },
//     { id: "devicemodal", path:"/devicemodal", component: <DeviceModelsPage />,roles: ["admin"], },
//     { id: "assignmap", path:"/assignmap", component: <OpsAllocationDistrictMap />,roles: ["admin"], },
    
//     // Admin Dashboard 
//     { id: "admindashboard", path: "/admindashboard", component: <AdminSuperPortal />,roles: ["company"], }, 
//     { id: "paymentlist", path: "/paymentlist", component: <CompanyPaymentsList />,roles: ["admin"], }, 
//     { id: "payment-details", path: "/company/payment-details/:paymentId", component: <PaymentDetails />,roles: ["admin","company"], }, 
//     { id: "admretailers", path: "/admretailers", component: <OperationsView />, roles: ["admin", "agent"], }, 
//     { id: "admagents", path: "/admagents", component: <AgentsView />,roles: ["admin","company"], }, 
//     { id: "admwrnty", path: "/admwrnty", component: <WarrantiesClaimsView />, roles: ["admin","agent","retailer"],}, 
//     { id: "admcomsn", path: "/admcomsn", component: <CommissionsView />,roles: ["admin"], }, 
//     // { id: "admtask", path: "/admtask", component: <AdTasksView />, roles: ["admin","company"], }, 
//     { id: "admlegal", path: "/admlegal", component: <LegalComplianceView />, roles: ["admin","company", "agent"], }, 
//     { id: "admretuser", path: "/admretuser", component: <RetailerUsersView />, roles: ["admin", "agent"], }, 
//     // { id: "admanltc", path: "/admanltc", component: <AnalyticsView />, roles: ["admin","company", "agent"], }, 
//     // { id: "assignproduct", path:"/assign-products/:companyId", component: <AssignCompanyProducts />, roles: ["admin"] },
//     { id: "warrantydetail", path:"/warranty-details/:id", component: <WarrantyDetails />, roles: ["admin","company", "retailer", "retailer_user" ] },
//     { id: "employeeadd", path:"/employees/add", component: <EmployeeForm />, roles: ["company"] },
//     { id: "employeeadd", path:"/employees/edit/:id", component: <EmployeeForm />, roles: ["company"] },
//     { id: "report-logs", path:"/report-logs", component: <WhatsappPanel />,roles: ["admin"], },
//     { id: "activation-report", path:"/activation-report", component: <ActivationReport />,roles: ["admin","company","retailer"], },

//     // employee dashboard 
//     { id: "empdash", path: "/empdashboard", component: <EmployeeDashboard />, roles: ["admin","company", "agent", "employee"], }, 
//     { id: "leadview", path:"/leads-view", component: <LeadsViewPage />,roles: ["admin","company", "agent","employee"], }, 
//     { id: "badgepackage", path:"/badgepackage", component: <BadgePackageDashboard />,roles: ["admin","company", "agent","employee"], },
//     { id: "Team Members", path:"/teammember", component: <TeamMember />,roles: ["admin","employee"], },

//     // Operation Dashboard 
//     { id: "oprdash", path:"/oprdashboard", component: <OperationDashboard />, roles: ["admin","company", "agent","employee"],}, 
//     { id: "oprret", path:"/oprretail", component: <OprRetailersView />,roles: ["admin","company", "agent","employee"],}, 
//     { id: "cardret", path:"/retailers", component: <RetailersPage />,roles: ["admin","company", "agent","employee"],}, 
//     // { id: "", path:"/oprtasks", component: <TasksView />, roles: ["admin","company", "agent","employee"],}, 
//     { id: "oprreports", path:"/oprreports", component: <ReportsView />, roles: ["admin","company", "agent","employee"],}, 
//     { id: "retailerview", path:"/retailer/:id", component: <RetailerDetailsPage />,roles: ["admin","company", "agent","employee"],}, 

//     // Agent Dashboard 
//     { id: "agentdashboard", path: "/agentdashboard", component: <AgentDashboard />,roles: ["agent"], }, 
//     { id: "agentretailers", path: "/agentretailers", component: <RetailersView />,roles: ["agent"], }, 
//     { id: "agtcom", path: "/agtcom", component: <CommissionView />, roles: ["agent"], }, 

//     // Retailer Dashboard 
//     { id: "retaileronboard", path: "/onboard", component: <RetailerOnboarding />, roles: ["company","agent","retailer","retailer_user"], }, 
//     { id: "retailerdashboard", path: "/retailerdashboard", component: <RetailerDashboard />,roles: ["retailer"], }, 
//     { id: "retwarnty", path: "/retwarnty", component: <WarrantyView />,roles: ["retailer", "retailer_user"], }, 
//     // { id: "retinv", path: "/retinv", component: <InvoicesView />,roles: ["retailer"], },
//     { id: "retinv", path: "/retinv", component: <InvoicesView />,roles: ["retailer", "admin", "retailer_user"], },
//     { id: "retinv", path: "/invoices/:invoiceId", component: <InvoiceDetailsPage />,roles: ["retailer", "company"], },
//     { id: "retproduct", path: "/retproduct", component: <RetailerProductView />,roles: ["retailer", ], },
//     { id: "ordersummery", path: "/ordersummery", component: <OrderCheckoutPage />,roles: ["retailer", ], },
//     // { id: "retledger", path: "/retledger", component: <LedgerView />, roles: ["retailer"], },
//     { id: "retuser", path: "/retuser", component: <UsersView />, roles: ["retailer"], }, 
//     { id: "retuserdoc", path: "/retuserdoc", component: <DocumentsView />, roles: ["retailer"], },
//     { id: "customer-create", path: "/customer-create", component: <CreateCustomer />, roles: ["retailer", "retailer_user"], },
//     { id: "customerlist", path: "/customerlist", component: <CustomerList />, roles: ["admin","retailer", "retailer_user"], },
//     { id: "customer-details", path: "/customer-details/:id", component: <CustomerDetails />, roles: ["admin","company", "agent","retailer", "retailer_user"], },
//     { id: "earnings", path: "/earnings", component: <RetailerWarrantyEarningsDashboard />, roles: ["company", "agent","retailer", "retailer_user"], },
//     { id: "modelpricelist", path: "/model-price-list", component: <ModelPriceList />, roles: ["admin","company","employee", "agent","retailer", "retailer_user"], },
//     { id: "rettransac", path: "/retailer-transactions", component: <RetailerTransactions />, roles: ["retailer"], },

//     // User Dashboard 
//     { id: "userdashboard", path: "/userdashboard", component: <RetailerDashboard />,roles: ["retailer_user"], }, 
//     // { id: "userwarnty", path: "/userwarnty", component: <UsrWarrantyView />,roles: ["retailer_user"], }, 
//     // { id: "userdoc", path: "/userdoc", component: <LegalView />,roles: ["retailer_user"], }, 
//     { id: "userprofile", path: "/userprofile", component: <ProfileView />, roles: ["retailer_user"], }, 

//     // Customer Dashboard
//     { id: "custdashboard", path: "/custdashboard", component: <CustomerWarrantyPortal />, roles: ["customer"] }, 
//     { id: "custwarnty", path: "/custwarnty", component: <WarrantiesView />, roles: ["customer"] }, 
//     { id: "custclaims", path: "/custclaims", component: <ClaimsView />, roles: ["customer"] }, 
//     { id: "custwarnty", path: "/custwarnty", component: <WarrantiesView />, roles: ["customer"] }, 
//     { id: "custdoc", path: "/custdoc", component: <CustLegalView />, roles: [ "customer"] },
//     { id: "custspt", path: "/custspt", component: <SupportView />, roles: ["customer"] },

//     // Profile 
//     { id: "profile", path: "/profile", component: <ProfileView />, roles: ["admin","company","agent","employee","retailer", "customer"] }, 
//     { id: "account", path: "/account", component: <Account />, roles: ["admin","company", "employee","agent","retailer", "customer"] },
//     // { id: "reset-password", path: "/reset-password", component: <ResetPassword />, roles: ["admin","company", "employee","agent","retailer","retailer_user", "customer"] },
//     // error page 
    
// ]; 

// export default allRoutes;

// import React from "react";
// import Dashboard from "../Pages/Main/Dashboard";
// import Employees from "../Pages/Main/Employee/Employees";
// import EmployeeForm from "../Pages/Main/Employee/EmployeeForm";
// import Agents from "../Pages/Main/Agent/Agents";
// import AddAgentForm from "../Pages/Main/Agent/AddAgentForm";
// import AgentDashboard from "../Pages/Main/Agent/AgentDashboard";
// import RetailersView from "../Pages/Main/Agent/Retailer/RetailersView";

// import Retailers from "../Pages/Main/Agent/Retailer/Retailers";
// import EmployeeDashboard from "../Pages/Employee/Dashboard";
// import AddRetailerForm from "../Pages/Main/Agent/Retailer/UpdateRetailerForm";
// import LeadsViewPage from "../Pages/Employee/LeadsViewPage";
// import OperationDashboard from "../Pages/Main/Operation/Dashboard";
// import OprRetailersView from "../Pages/Main/Operation/RetailersView";
// import RetailersPage from "../Pages/Main/Operation/RetailersPage";
// import TasksView from "../Pages/Main/Operation/TasksView";
// import ReportsView from "../Pages/Main/Operation/ReportsView";
// import CommissionView from "../Pages/Main/Agent/CommissionView";
// import RetailerDashboard from "../Pages/Main/Retailer/RetailerDashboard";
// import WarrantyView from "../Pages/Main/Retailer/WarrantyView";
// import InvoicesView from "../Pages/Main/Retailer/InvoicesView";
// import LedgerView from "../Pages/Main/Retailer/LedgerView";
// import UsersView from "../Pages/Main/Retailer/UsersView";
// import DocumentsView from "../Pages/Main/Retailer/DocumentsView";
// import RetailerUserDashboard from "../Pages/Main/RetailerUser/RetailerUserDashboard";
// import UsrWarrantyView from "../Pages/Main/RetailerUser/WarrantyView";
// import LegalView from "../Pages/Main/RetailerUser/LegalView";
// import ProfileView from "../Pages/Main/RetailerUser/ProfileView";
// import CustomerWarrantyPortal from "../Pages/Main/Customer/CustDashboard";
// import WarrantiesView from "../Pages/Main/Customer/WarrantiesView";
// import ClaimsView from "../Pages/Main/Customer/ClaimsView";
// import CustLegalView from "../Pages/Main/Customer/LegalView";
// import SupportView from "../Pages/Main/Customer/SupportView";
// import AdminSuperPortal from "../Pages/Main/Admin/AdminSuperPortal";
// import OverviewView from "../Pages/Main/Admin/OverviewView";
// import OperationsView from "../Pages/Main/Admin/OperationsView";
// import RetailerUsersView from "../Pages/Main/Admin/RetailerUsersView";
// import AgentsView from "../Pages/Main/Admin/AgentsView";
// import WarrantiesClaimsView from "../Pages/Main/Admin/WarrantiesClaimsView";
// import CommissionsView from "../Pages/Main/Admin/CommissionsView";
// import AdTasksView from "../Pages/Main/Admin/TasksView";
// import LegalComplianceView from "../Pages/Main/Admin/LegalComplianceView";
// import AnalyticsView from "../Pages/Main/Admin/AnalyticsView";
// import RetailerDetailsPage from "../Pages/Main/Operation/RetailerDetailsPage";
// import SuperAdminPortal from "../Pages/Main/SuperAdmin/SuperAdminPortal";
// import CategoriesView from "../Pages/Main/SuperAdmin/CategoriesView";
// import BrandView from "../Pages/Main/SuperAdmin/BrandView";
// import ProductView from "../Pages/Main/SuperAdmin/ProductView";
// import Account from "../Pages/Profile/Account";
// import AddEntityForm from "../Pages/Main/Admin/AddEntityForm";
// import CompanyView from "../Pages/Main/Admin/CompanyView";
// import RetailerOnboarding from "../Pages/Main/Agent/Retailer/onboarding";
// import BadgePackageDashboard from "../Pages/Badge&Package/BadgePackageDashboard";
// import AssignCompanyProducts from "../Pages/Main/Admin/AssignCompanyProducts";

// const allRoutes = [

//   // Super Admin
//   { id: "superdashboard", path: "/superdashboard", component: <SuperAdminPortal />, roles: ["admin"] },
//   { id: "categories", path: "/categories", component: <CategoriesView />, roles: ["admin"] },
//   { id: "brands", path: "/brands", component: <BrandView />, roles: ["admin"] },
//   { id: "products", path: "/products", component: <ProductView />, roles: ["admin"] },

//   // Company / Admin Area
//   { id: "dashboard", path: "/dashboard", component: <AdminSuperPortal />, roles: ["company"] },
//   { id: "amdcomp", path: "/amdcomp", component: <CompanyView />, roles: ["admin"] },
//   { id: "amdagent", path: "/amdagent", component: <AgentsView />, roles: ["admin"] },
//   { id: "allemployees", path: "/allemployees", component: <Employees />, roles: ["admin", "company"] },
//   { id: "add-employee", path: "/add-employee", component: <EmployeeForm />, roles: ["admin","company"] },

//   { id: "allagents", path: "/allagents", component: <Agents /> },
//   { id: "add-agent", path: "/add-agent", component: <AddAgentForm /> },
//   { id: "allretailers", path: "/allretailers", component: <Retailers /> },
//   { id: "add-retailer", path: "/add-retailer", component: <AddRetailerForm /> },

//   { id: "add-entity", path: "/add-entity/:type", component: <AddEntityForm />, roles: ["admin","company","agent"] },

//   // Assignment
//   { id: "assignproduct", path:"/assign-products/:companyId", component: <AssignCompanyProducts />, roles: ["admin"] },

//   // Employee Dashboard
//   { id: "empdash", path: "/empdashboard", component: <EmployeeDashboard />, roles: ["admin","company","agent","employee"] },
//   { id: "leadview", path:"/leads-view", component: <LeadsViewPage />, roles: ["admin","company","agent","employee"] },
//   { id: "badgepackage", path:"/badgepackage", component: <BadgePackageDashboard />, roles: ["admin","company","agent","employee"] },

//   // Operations Dashboard
//   { id: "oprdash", path:"/oprdashboard", component: <OperationDashboard />, roles: ["admin","company","agent","employee"] },
//   { id: "oprret", path:"/oprretail", component: <OprRetailersView />, roles: ["admin","company","agent","employee"] },
//   { id: "cardret", path:"/retailers", component: <RetailersPage />, roles: ["admin","company","agent","employee"] },
//   { id: "oprtasks", path:"/oprtasks", component: <TasksView />, roles: ["admin","company","agent","employee"] },
//   { id: "oprreports", path:"/oprreports", component: <ReportsView />, roles: ["admin","company","agent","employee"] },
//   { id: "retailerview", path:"/retailer/:id", component: <RetailerDetailsPage />, roles: ["admin","company","agent","employee"] },

//   // Agent Dashboard
//   { id: "agentdashboard", path: "/agentdashboard", component: <AgentDashboard />, roles: ["agent"] },
//   { id: "agentretailers", path: "/agentretailers", component: <RetailersView />, roles: ["agent"] },
//   { id: "agtcom", path: "/agtcom", component: <CommissionView />, roles: ["agent"] },

//   // Retailer
//   { id: "retaileronboard", path: "/onboard", component: <RetailerOnboarding />, roles: ["company","agent","retailer"] },
//   { id: "retailerdashboard", path: "/retailerdashboard", component: <RetailerDashboard />, roles: ["retailer"] },
//   { id: "retwarnty", path: "/retwarnty", component: <WarrantyView />, roles: ["retailer"] },
//   { id: "retinv", path: "/retinv", component: <InvoicesView />, roles: ["retailer"] },
//   { id: "retledger", path: "/retledger", component: <LedgerView />, roles: ["retailer"] },
//   { id: "retuser", path: "/retuser", component: <UsersView />, roles: ["retailer"] },
//   { id: "retuserdoc", path: "/retuserdoc", component: <DocumentsView />, roles: ["retailer"] },

//   // Retailer User
//   { id: "userdashboard", path: "/userdashboard", component: <RetailerUserDashboard />, roles: ["retailer"] },
//   { id: "userwarnty", path: "/userwarnty", component: <UsrWarrantyView />, roles: ["retailer"] },
//   { id: "userdoc", path: "/userdoc", component: <LegalView />, roles: ["retailer"] },
//   { id: "userprofile", path: "/userprofile", component: <ProfileView />, roles: ["retailer"] },

//   // Customer
//   { id: "custdashboard", path: "/custdashboard", component: <CustomerWarrantyPortal />, roles: ["retailer","customer"] },
//   { id: "custwarnty", path: "/custwarnty", component: <WarrantiesView />, roles: ["retailer","customer"] },
//   { id: "custclaims", path: "/custclaims", component: <ClaimsView />, roles: ["retailer","customer"] },
//   { id: "custdoc", path: "/custdoc", component: <CustLegalView />, roles: ["retailer","customer"] },
//   { id: "custspt", path: "/custspt", component: <SupportView />, roles: ["retailer","customer"] },

//   // Profile
//   { id: "profile", path: "/profile", component: <ProfileView />, roles: ["admin","company","agent","retailer","customer"] },
// ];

// export default allRoutes;

